export default `/* Ids Swipe Container Css */
.ids-swipe-container {
  display: flex;
  overflow-x: scroll;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  margin-left: -1px;
  border-radius: var(--ids-card-border-radius);
}
.ids-swipe-container.continuous {
  scroll-snap-type: x proximity;
}
.ids-swipe-container.continuous .ids-swipe-action-left,
.ids-swipe-container.continuous .ids-swipe-action-right {
  scroll-snap-align: initial;
}

.ids-swipe-container::-webkit-scrollbar {
  display: none;
}

.swipe-container {
  scrollbar-width: none;
}

.ids-swipe-element {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: var(--ids-space-sm);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  scroll-snap-align: start;
  scroll-snap-stop: always;
  min-width: calc(100% - 32px);
}

.ids-swipe-action {
  border-radius: 6px;
  display: flex;
  align-items: center;
  min-width: 100%;
}

.ids-swipe-action-left {
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.ids-swipe-action-right {
  justify-content: flex-end;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

::slotted(ids-button) {
  display: contents;
  position: sticky;
}

/* stylelint-disable-next-line at-rule-no-vendor-prefix */
@-moz-document url-prefix("") {
  .ids-swipe-container {
    overflow-x: hidden;
  }
  .ids-swipe-action-left {
    display: none;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
